module.exports = __webpack_public_path__ + "media/images/bsmart/icons/da_svolgere_test_ufficiale-b2e5840557cc7874fd7a7ee89aa866ec.svg";